var map = {
	"./bet_h.png": 9258,
	"./dl_h.png": 5332,
	"./hd_h.png": 6783,
	"./home_h.png": 610,
	"./jinbi_h.png": 2963,
	"./jy_h.png": 3761,
	"./recharge_h.png": 1730,
	"./tx_h.png": 2231,
	"./znx_h.png": 8820,
	"./zuanshi_h.png": 8046
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 600;